<template>
  <div class="rootDiv">
    <div class="infoStyle">
      <span class="titleSpan">更换手机号码</span>
      <br>
      <span class="decSpan">可通过新的手机号码找回密码、验证身份</span>
    </div>
    <Field label="+86" placeholder="请输入新的手机号码" type="tel" v-model="input_phone" :attr="{ maxlength: 11 }"
           @keyup.native.capture="activeLogin()"></Field>
    <div class="buttonDiv">
      <Button :disabled="isForbidden" class="submitButton" type="primary" size="large" @click="nextStep">下一步</Button>
    </div>
  </div>
</template>

<script>
import {Button, Field} from 'mint-ui';
import VerificationCode from "../../../../controls/VerificationCode";

export default {
  name: "ChangeNewPhone",
  components: {Field, Button},

  data() {
    return {
      account: null,
      oldPhone: null,
      //按钮禁用
      isForbidden: true,
      input_phone: null,
      token: localStorage.getItem('token'),
      checkPhoneUrl: '/api/user/checkPhone',
      verifyCodeUrl: '/api/verifyCode/getVerifyCode',
    }
  },
  mounted() {
    if (this.$route.params.code === undefined || this.$route.params.code === null || this.$route.params.code !== 'cdjcaivi') {
      this.$router.go(-1)
    }
    this.oldPhone = this.$route.params.data['phone']
    this.account = this.$route.params.data['account']
  },
  methods: {
    nextStep() {
      if (this.oldPhone === this.input_phone) {
        this.$messagebox.alert("该手机号与当前绑定的手机号相同")
        return
      }
      /**验证新输入的手机号码是否已被绑定**/
      let that = this
      that.$ajax({
        method: 'get',
        url: that.checkPhoneUrl,
        params: {phone: that.input_phone},
        headers: {token: that.token}
      }).then((response) => {
        if (response.data.result) {
          let responseData = JSON.parse(response.data['responseData'])
          let bo = Boolean(Number(responseData))
          if (bo) {
            that.$messagebox.alert("该手机号已被注册")
          } else {
            let ver_code_ide = '2'
            let data = VerificationCode.data().requestData
            data.title = '验证新手机号码'
            data.phone = that.input_phone
            data.nextPage = 'm_after_verification'
            data.ver_code_ide = ver_code_ide
            data.business = 'ChangePhoneNumber'
            data.data = {
              phone: that.input_phone,
              business: 'ChangePhoneNumber',
              nextPage: 'm_account_setting',
              account: that.account
            }

            /**发送验证码**/
            that.$ajax({
              method: 'get',
              url: that.verifyCodeUrl,
              params: {phoneNumber: that.input_phone, key: data.business}
            }).then((response) => {
              that.$toast({
                message: response.data.message,
                position: 'middle',
              });
              if (response.data.result) {
                let nowTime = new Date().getTime();
                localStorage.setItem(`startTime${ver_code_ide}`, nowTime);
                let requestData = JSON.stringify(data);
                that.$router.replace({name: 'm_verification_code', query: {requestData: requestData}})
              } else {
                that.$messagebox.alert(response.data.message)
              }
            }).catch(response => {
              that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
            })
          }
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    activeLogin() {
      //判空
      let code = this.input_phone
      let code_empty = code === "" || code === null || code === undefined;
      if (code && code.length === 11) {
        //激活登录按钮
        this.isForbidden = code_empty
      }
    },
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  text-align: left;
  background-color: transparent;
  margin-top: -0.5rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;

  .infoStyle {
    background-color: white;
    margin-bottom: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;

    .titleSpan {
      margin-left: 1rem;
      font-size: 1.8rem;
    }

    .decSpan {
      margin-left: 1rem;
      margin-top: 1.5rem;
      font-size: 0.8rem;
    }
  }
}

.buttonDiv {

  .submitButton {
    width: 95%;
    display: block;
    margin: 2rem auto;
  }
}
</style>
